import {
  Payout_Gateway_Enum,
  Payment_Gateway_Enum,
} from 'src/app/models/portal';
import { Component, OnInit, Input } from '@angular/core';

export enum PaymentMethodViewTypeEnum {
  icon = 'icon',
  text = 'text',
  both = 'both',
}
@Component({
  selector: 'app-system-payment-method-view',
  templateUrl: './system-payment-method-view.component.html',
  styleUrls: ['./system-payment-method-view.component.css'],
})
export class SystemPaymentMethodViewComponent implements OnInit {
  paymentGateway = Payment_Gateway_Enum;
  paymentMethodViewTypeEnum = PaymentMethodViewTypeEnum;

  @Input() methodEnum: Payment_Gateway_Enum;
  enums: [] = [];
  @Input() type: PaymentMethodViewTypeEnum = PaymentMethodViewTypeEnum.text;
  @Input() iconSize: number = 50;
  constructor() {}

  ngOnInit(): void {}


}
